export default Object.freeze({
  ADMIN: 'ADMIN',
  PUBLIC: 'PUBLIC',
});
